export const DND_BASIC_TYPE = "TASK";
